import { motion } from "framer-motion";
import { useEffect, useState } from "react";
import { useOutletContext } from "react-router-dom";

export default function Members() {
  const [isVisible, setIsVisible] = useState(false);
  const { theme } = useOutletContext();

  const chennaiLogos = [
    "logo--1.jpg", "logo-2.jpg", "logo-3.jpg", "logo-4.jpg",
    "logo-5.jpg", "logo-6.jpg", "logo-7.jpg", "logo-8.jpg"
  ];
  const puneLogos = [
    "logo--5.jpg", "logo--6.jpg", "logo-1.jpg", "logo-2.jpg",
    "logo-3.jpg", "logo-4.jpg"
  ];

  const sponsors = [
    ...chennaiLogos.map((filename, index) => ({
      id: `chennai-${index}`,
      src: `https://res.cloudinary.com/dlz2bvrk0/image/upload/q_auto,f_auto,w_300/v1770450708/hive/logo/chennai/${filename}`,
      alt: `Chennai Member ${index + 1}`,
    })),
    ...puneLogos.map((filename, index) => ({
      id: `pune-${index}`,
      src: `https://res.cloudinary.com/dlz2bvrk0/image/upload/q_auto,f_auto,w_300/v1770450701/hive/logo/pune/${filename}`,
      alt: `Pune Member ${index + 1}`,
    })),
  ];

  const duplicatedSponsors = [...sponsors, ...sponsors, ...sponsors];

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <section
      className={`
        py-6 overflow-hidden relative mx-auto
        ${theme === "dark" ? "bg-black text-white" : "bg-white text-black"}
      `}
    >
      <div className="max-w-[90%] mx-auto relative z-10">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: isVisible ? 1 : 0, y: isVisible ? 0 : 30 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          className="mb-10 text-center"
        >
          <h2
            className={`text-3xl mb-5 md:text-4xl liber ${theme === "dark" ? "text-white" : "text-black"
              }`}
          >
            Our Business Partners
          </h2>

          <p
            className={`
              text-sm max-w-2xl mx-auto
              ${theme === "dark" ? "text-gray-300" : "text-gray-600"}
            `}
          >
            Trusted by leading businesses and growing teams across India.
          </p>
        </motion.div>

        {/* Marquee */}
        <div className="overflow-hidden relative">
          <div className="flex gap-8 md:gap-12 animate-marquee">
            {duplicatedSponsors.map((sponsor, index) => (
              <div
                key={`${sponsor.id}-${index}`}
                className="flex-shrink-0 flex items-center py-2 justify-center px-2"
              >
                <img
                  src={sponsor.src}
                  alt={sponsor.alt}
                  className="h-16 py-4 px-3 md:h-20 border border-gray-400 w-auto object-contain members-image max-w-[150px]"
                  loading="lazy"
                  crossOrigin="anonymous"
                  style={{
                    borderRadius: "15px 0px 15px 0px"
                  }}
                />
              </div>
            ))}
          </div>
        </div>
      </div>

      <style>{`
        @keyframes marquee {
          0% { transform: translate3d(0, 0, 0); }
          100% { transform: translate3d(-33.333%, 0, 0); }
        }
        .animate-marquee {
          animation: marquee 20s linear infinite;
          will-change: transform;
          display: flex;
          width: max-content;
        }
        .animate-marquee:hover {
          animation-play-state: paused;
        }
        @media (max-width: 768px) {
          .animate-marquee {
            animation-duration: 12s; /* Faster on mobile to compensate for shorter distance */
          }
        }
      `}</style>
    </section>
  );
}
